// services/profileNavigationService.ts
import { routePath } from "config/routeMgt/routePath";

export type SectionKey =
  | "Basic Details"
  | "Education"
  | "Experience"
  | "URLs"
  | "Interests"
  | "Certifications"
  | "Projects";

interface MenuItem {
  label: SectionKey;
  link: string;
  required: boolean;
}

export const MENU_ITEMS: MenuItem[] = [
  { label: "Basic Details", link: routePath.settings, required: true },
  { label: "Education", link: routePath.education, required: true },
  { label: "Experience", link: routePath.experience, required: true },
  { label: "URLs", link: routePath.urls, required: false },
  { label: "Interests", link: routePath.interests, required: false },
  { label: "Certifications", link: routePath.certifications, required: false },
  { label: "Projects", link: routePath.projects, required: false },
];

export const getNextSection = (currentPath: string): MenuItem | null => {
  const currentIndex = MENU_ITEMS.findIndex(
    (item) => item.link === currentPath,
  );
  if (currentIndex !== -1 && currentIndex < MENU_ITEMS.length - 1) {
    return MENU_ITEMS[currentIndex + 1];
  }
  return null;
};

export const getPreviousSection = (currentPath: string): MenuItem | null => {
  const currentIndex = MENU_ITEMS.findIndex(
    (item) => item.link === currentPath,
  );
  if (currentIndex > 0) {
    return MENU_ITEMS[currentIndex - 1];
  }
  return null;
};

export const isLastSection = (currentPath: string): boolean => {
  const currentIndex = MENU_ITEMS.findIndex(
    (item) => item.link === currentPath,
  );
  return currentIndex === MENU_ITEMS.length - 1;
};

export const isFirstSection = (currentPath: string): boolean => {
  const currentIndex = MENU_ITEMS.findIndex(
    (item) => item.link === currentPath,
  );
  return currentIndex === 0;
};

export const getCurrentSection = (currentPath: string): MenuItem | null => {
  return MENU_ITEMS.find((item) => item.link === currentPath) || null;
};
